import { useRef } from 'react'
import { Divider } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useLogEventOnMount } from 'lib/hooks/useLogEventOnMount/useLogEventOnMount'
import { type ModalWithConditionalProps, Modal } from 'settle-ui/components/Modal/Modal'
import type { googleCalendarSchedules } from 'lib/consts/externalLinks'
import { sessionStorageKeys } from 'lib/consts/browserStorage'
import { MODAL_OPEN } from './ScheduleDemoDialog.events'

export interface ScheduleDemoDialogProps extends ModalWithConditionalProps {
  url: DeepValueOf<typeof googleCalendarSchedules>
  onClose(): void
}

export const ScheduleDemoDialog = Modal.withConditional<ScheduleDemoDialogProps>(({ onClose, url, ...props }) => {
  const { t } = useTranslation()

  useLogEventOnMount(MODAL_OPEN, { url })

  const { current: openedAt } = useRef(Date.now())

  const handleClose = () => {
    const wasOpenLongEnough = Date.now() - openedAt > 2000

    if (wasOpenLongEnough) {
      sessionStorage.setItem(sessionStorageKeys.isDemoScheduled, 'true')
    }

    onClose()
  }

  return (
    <Modal {...props} size="xxl" onClose={handleClose}>
      <Modal.Header title={t('scheduleDemoDialog::title')} onClose={handleClose} />
      <Modal.Content dividers="none" sx={{ paddingX: 0, paddingY: 0, height: '850px', overflow: 'hidden' }}>
        <Divider />
        <iframe
          style={{ border: 0, background: 'transparent', maxHeight: '100%', maxWidth: '100%' }}
          height="100%"
          width="100%"
          src={url}
        />
      </Modal.Content>
    </Modal>
  )
})
